import {
  IS_ASSIGNED,
  RESET_STORE,
  SET_IS_VALID_LOGIN,
  SET_MENU,
} from "../types";

const initialState = {
  menu: null,
};

export const menuReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_MENU:
      return { ...state, menu: payload };
    case RESET_STORE:
      return initialState;
    default:
      return state;
  }
};
